/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AuthScheme {
  Native = 'Native',
  Redirect = 'Redirect',
  WebView = 'WebView'
}
